<mat-form-field id="langChoice" style="padding-top: 0px; margin-top: 0px;">
  <mat-select [(ngModel)]="selectedLangage" (ngModelChange)="onChange($event)" style="padding-top: 0px; margin-top: 0px;" 
                ngDefaultControl >
    
    <mat-option class="selectOptionsTheme" *ngFor="let lang of supportedLangs" selected="isCurrentLang(lang)" [value]="lang"  >{{ lang.display | translate }}</mat-option>
  </mat-select>
</mat-form-field>
